import React from 'react';
export function ResourcesHero() {
  return <section className="w-full bg-white pt-16 md:pt-20 pb-12 md:pb-14 px-4 sm:px-6 lg:px-8 border-b border-gray-100" data-id="element-154" data-mp="2ikk57v3vupke">
      <div className="max-w-4xl mx-auto" data-id="element-155" data-mp="dv2jk4taetzz">
        <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-brand-navy mb-10 leading-tight" data-id="element-156" data-mp="3v6bw97buiwps">
          Ideas, frameworks, and practical AI thinking
        </h1>
        <p className="text-xl md:text-2xl text-brand-gray leading-relaxed" data-id="element-157" data-mp="rp3l16bmiv41">
          I write and teach about AI transformation, leadership, and the
          organizational challenges of adopting new technology. Here's where to
          find all of it.
        </p>
      </div>
    </section>;
}